/**
 * @author @Simo mailto:simoneolivieri@kubepartners.com
 * @description //import pagelist navigation
 * @date 09:40 18/04/23
 * @param ~/nav.json
 * @return pagelist
 **/
import pagelist from '~/nav.json';
import {brandNames} from '~/assets/config/brandNames';


/**
 * @author @Simo mailto:simoneolivieri@kubepartners.com
 * @description server side store filters api
 * @date 08:55 25/03/2022
 * @revision 15:07 25/03/2022  @author simoneolivieri @description import storeFilters
 **/
export const state = () => ({
	navigation: [],
	domain: null,
	idgroup: null,
	filtersdata: [],
	presets_motor: [],
	presets_home: [],
	companydata: [],
	currentPayload: null,
	loaded: false,
	isfilters: false,
	isdatatable: false,
	role: null,
	preset_selected_motor: 0,
	preset_selected_home: 0,
	nav_slot:null,
	companyName: null
})

export const mutations = {
	SET_NAVIGATION(state, navigation) {
		state.navigation = navigation
	},
	SET_DOMAIN(state, domain) {
		state.domain = domain
	},
	SET_GROUP_ID(state, id) {
		state.idgroup = id;
	},
	SET_FILTERS(state, filters) {
		state.filtersdata = filters
	},
	SET_PRESETS_MOTOR(state, presets) {
		state.presets_motor = presets
	},
	SET_PRESETS_HOME(state, presets) {
		state.presets_home = presets
	},
	SET_DATA(state, data) {
		// it can we saved as array with multiple storage sessions
		// state.urldata.push(url)
		// otherwise only one
		state.companydata = data
		// state.companydata.push(data)
	},
	LOADED(state, loaded) {
		state.loaded = loaded
	},
	IS_FILTERS(state, active) {
		state.isfilters = active;
	},
	IS_DATATABLE(state, active) {
		state.isdatatable = active;
	},
	SET_ROLE(state, role) {
		state.role = role
	},
	SET_PRES_SEL_MOTOR(state, sel) {
		state.preset_selected_motor = sel
	},
	SET_PRES_SEL_HOME(state, sel) {
		state.preset_selected_home = sel
	},
	SET_NAV_SLOT(state, slot) {
		state.nav_slot = slot
	},
	SET_COMPANY_NAME(state, name) {
		state.companyName = name
	},
	SET_PAYLOAD(state, payload) {
		state.currentPayload = payload
	}
}

export const actions = {
	async nuxtServerInit({commit}, {store, $config}) {
		/**
		 * @author @Simo mailto:simoneolivieri@kubepartners.com
		 * @description //store navigation on server init
		 * @date 09:40 18/04/23
		 * @param SET_NAVIGATION
		 * @return navigation
		 * @param SET_DOMAIN
		 * @return 'motor'
		 **/
		const lineOfBusiness = process.env.LINE_OF_BUSINESS;
		const allowedSections = lineOfBusiness.split(',').map(s => s.trim()).filter(Boolean);

		const enabledPages = $config.enabledPages || {};
		const enabledPagesBySection = $config.enabledPagesBySection || {};
		const excludedFromFlags = ['motor_dash', 'home_dash', 'login'];

		const filteredNav = {};
		allowedSections.forEach(section => {
			if (pagelist[section]) {
				let sectionItems = pagelist[section];
				sectionItems = sectionItems.filter(item => {
					const pageName = item.path.split('/').pop();
					if (excludedFromFlags.includes(pageName)) return true;
					const sectionPageConfig = enabledPagesBySection[section] || {};
					return enabledPages[pageName] !== false && sectionPageConfig[pageName] !== false;
				});
				filteredNav[section] = sectionItems;
			}
		});

		const firstDomain = allowedSections.find(s => filteredNav[s]);

		commit('SET_NAVIGATION', filteredNav)
		commit('SET_DOMAIN', firstDomain)
		console.log('navigation stored')
	},
	RESET_STATE({commit}) {
		/**
		 * @description Reset all persisted state to initial values
		 * Called on logout or authentication failure (401)
		 */
		commit('SET_DOMAIN', null)
		commit('SET_GROUP_ID', null)
		commit('SET_FILTERS', [])
		commit('SET_PRESETS_MOTOR', [])
		commit('SET_PRESETS_HOME', [])
		commit('SET_DATA', [])
		commit('LOADED', false)
		commit('IS_FILTERS', false)
		commit('IS_DATATABLE', false)
		commit('SET_ROLE', null)
		commit('SET_PRES_SEL_MOTOR', 0)
		commit('SET_PRES_SEL_HOME', 0)
		commit('SET_NAV_SLOT', null)
		commit('SET_COMPANY_NAME', null)
		commit('SET_PAYLOAD', null)
	}
}

export const getters = {
	isAuthenticated(state) {
		return state.auth.loggedIn
	},

	loggedInUser(state) {
		return state.auth.user
	},

	getCompanyName(state) {
		return state.companyName || (brandNames[process.env.AGENT] || process.env.AGENT)
	}
}
